import HttpService from "service/HttpService";
import {
    BackupApi,
    LogsApi,
    ManagementApi,
    MeasurementApi,
    ObjectApi,
    TestingApi,
    ToolsApi,
    ActionsApi,
    PostprocessorApi,
    EASASDatasetsApi,
    DatasetDataApi,
    VersionApi as VersionApiDC
} from "./dataCollectorApi";
import {
    ManagementApi as ManagementApiConst,
    BackupApi as BackupApiConst,
    LogsApi as writerLogsConst,
    ActionsApi as ActionsApiWriter,
    VersionApi,
    DataApi
} from "./dataPusherApi";
import {ApiConfig} from "../axios/Config";
import {apisStore} from "context/GlobalStates";
import { EasasAirflowApi, JobsApi, EasasScheduledTasksApi, JobrunnerLogsApi, EasasDatasetsApi, VersionApi as VersionApiJR } from "./jobRunnerApi";

export type apisType = {
    objectsApi: ObjectApi;
    managementApi: ManagementApi;
    testingApi: TestingApi;
    measurementApi: MeasurementApi;
    logsApi: LogsApi;
    toolsApi: ToolsApi;
    backupApi: BackupApi;
    actionsApi: ActionsApi;
    postprocessorApi: PostprocessorApi;
    easasAirflowApi: EasasAirflowApi;
    easasScheduledTasksApi: EasasScheduledTasksApi;
    datasetsApi: EasasDatasetsApi;
    datasetsApiDC: EASASDatasetsApi;
    datasetDataApi: DatasetDataApi;
    jobrunnerLogsApi: JobrunnerLogsApi;
    jobsApi: JobsApi;
    dataApi: DataApi;
    writerActionsApi: ActionsApiWriter;
    writerBackupApi: BackupApiConst;
    managementApiConst: ManagementApiConst;
    writerLogs: writerLogsConst;
    versionApi: VersionApi;
    versionApiJR: VersionApiJR;
    versionApiDC: VersionApiDC;
}

const Apis = (page?: string): apisType => {
    let baseURL = apisStore.getState().serviceId ?
        process.env.REACT_APP_BACKEND_BASE_URL + `${page}` as string :
        ApiConfig.getBaseUrl();
        
    if (page === "datacollector") {
        baseURL = baseURL.replaceAll(/jobrunner|datapusher/g, page)
    } else if (page === "datapusher") {
        baseURL = baseURL.replaceAll(/datacollector|jobrunner/g, page)
    } else if (page === "jobrunner") {
        baseURL = baseURL.replace(/datacollector|datapusher/g, page);
    }

    const dataCollectorAxios = HttpService.get_dataCollectorAxios(apisStore.getState().serviceId);
    const objectsApi = new ObjectApi(undefined, baseURL, dataCollectorAxios);
    const managementApi = new ManagementApi(undefined, baseURL, dataCollectorAxios);
    const testingApi = new TestingApi(undefined, baseURL, dataCollectorAxios);
    const measurementApi = new MeasurementApi(undefined, baseURL, dataCollectorAxios);
    const logsApi = new LogsApi(undefined, baseURL, dataCollectorAxios);
    const toolsApi = new ToolsApi(undefined, baseURL, dataCollectorAxios);
    const backupApi = new BackupApi(undefined, baseURL, dataCollectorAxios);
    const actionsApi = new ActionsApi(undefined, baseURL, dataCollectorAxios);
    const postprocessorApi = new PostprocessorApi(undefined, baseURL, dataCollectorAxios);
    const datasetsApiDC = new EASASDatasetsApi(undefined, baseURL, dataCollectorAxios);
    const datasetDataApi = new DatasetDataApi(undefined, baseURL, dataCollectorAxios);
    const versionApiDC = new VersionApiDC(undefined, baseURL, dataCollectorAxios);

    const dataWriterAxios = HttpService.get_dataPusherAxios(apisStore.getState().serviceId);
    const managementApiConst = new ManagementApiConst(undefined, baseURL, dataWriterAxios)
    const writerActionsApi = new ActionsApiWriter(undefined, baseURL, dataWriterAxios);
    const writerBackupApi = new BackupApiConst(undefined, baseURL, dataWriterAxios);
    const writerLogs = new writerLogsConst(undefined, baseURL, dataWriterAxios);
    const dataApi = new DataApi(undefined, baseURL, dataWriterAxios);

    const versionApi = new VersionApi(undefined, baseURL, dataWriterAxios);
    const jobRunnerAxios = HttpService.get_dataPusherAxios(apisStore.getState().serviceId);
    const easasAirflowApi = new EasasAirflowApi(undefined, baseURL, jobRunnerAxios);
    const easasScheduledTasksApi = new EasasScheduledTasksApi(undefined, baseURL, jobRunnerAxios);
    const datasetsApi = new EasasDatasetsApi(undefined, baseURL, jobRunnerAxios);
    const jobrunnerLogsApi = new JobrunnerLogsApi(undefined, baseURL, jobRunnerAxios);
    const jobsApi = new JobsApi(undefined, baseURL, jobRunnerAxios);
    const versionApiJR = new VersionApiJR(undefined, baseURL, jobRunnerAxios);

    apisStore.setState((state) => ({
        ...state,
        jobRunner: {
          ...state.jobRunner,
          easasAirflowApi,
          easasScheduledTasksApi,
          jobrunnerLogsApi,
          jobsApi,
          datasetsApi,
          versionApiJR
        },
        dataCollector: {
            ...state.dataCollector,
            datasetsApiDC,
            datasetDataApi,
            versionApiDC
        },
        dataPusher: {
            ...state.dataPusher,
            writerActionsApi,
            managementApiConst,
            writerBackupApi,
            writerLogs,
            dataApi,
            versionApi
        }
      }));

    return Object.freeze({
        objectsApi,
        managementApi,
        testingApi,
        measurementApi,
        datasetsApiDC,
        logsApi,
        toolsApi,
        backupApi,
        managementApiConst,
        writerBackupApi,
        actionsApi,
        postprocessorApi,
        easasAirflowApi,
        easasScheduledTasksApi,
        datasetsApi,
        datasetDataApi,
        jobrunnerLogsApi,
        jobsApi,
        dataApi,
        writerLogs,
        writerActionsApi,
        versionApi,
        versionApiJR,
        versionApiDC
    })
}


export default Apis;